module.exports = __webpack_public_path__ + "static/media/menu-subscription-selected.d842fd60.svg";